import React, { createContext, useContext, useState } from "react";

const ErrorContext = createContext();

export const ErrorProvider = ({ children }) => {
    const [error, setError] = useState(null);

    const showMessage = (message, timeout = 5000) => {
        setError(message);
        if (timeout) {
            setTimeout(() => setError(null), timeout);
        }
    };

    const clearError = () => setError(null);

    return (
        <ErrorContext.Provider value={{ error, showMessage, clearError }}>
            {children}
        </ErrorContext.Provider>
    );
};

export const useError = () => useContext(ErrorContext);